import { type RGBColorNumber, rgbStringToNumber } from './utils/rgb';

export const rgbColors = {
  black: '#333333',
  blue: '#66b2ff',
  blueDark: '#4F81BD',
  blueLight: '#99ccff',
  gray: '#a0a0a0',
  green: '#6fb96f',
  greenDark: '#497349',
  lime: '#00ff00',
  orange: '#ff9800',
  orangeDark: '#b87108',
  orangeLight: '#ffbb00',
  pink: '#ff9999',
  red: '#ff6666',
  redDark: '#b14c4b',
  white: '#ffffff',
};

type ColorName = keyof typeof rgbColors;

export const rgbColorNumbers = Object.entries(rgbColors).reduce(
  (acc, [name, rgb]) => Object.assign(acc, { [name]: rgbStringToNumber(rgb) }),
  {},
) as { [name in ColorName]: RGBColorNumber };
